export default {
  no_results: {
    title: 'No results for "{{search}}"',
    desc: 'Sorry, we couldn’t find a match. Please try a different seach term.',
  },
};
